import { disableCalendarModuleCommandingHotkeys } from '../utils/bindCalendarModuleCommandingHotKeys';
import { disableCalendarModuleHotkeys } from '../utils/bindCalendarModuleHotKeys';
import { disableAppModuleHotkeys } from 'owa-app-module/lib/utils/moduleHotKeys';
import { onRequestModuleCommand } from 'owa-calendar-module-command';
import { orchestrator } from 'satcheljs';

orchestrator(onRequestModuleCommand, () => {
    // disable global hotkeys so we don't accidentally invoke compose or navigate the view while popups are open
    disableCalendarModuleHotkeys();
    disableCalendarModuleCommandingHotkeys();
    disableAppModuleHotkeys();
});
